import styled, { css } from 'styled-components';

import { colors } from 'utils/styles/theme';

interface ArticlesProps {
  hoverTextColor?: string;
}

export const Wrapper = styled.section`
  margin-top: 42px;
`;

export const Article = styled.article`
  padding: 8px 0;

  &:not(:last-child) {
    border-bottom: 1px solid ${colors.brightGray};
  }
`;

export const Articles = styled.div<ArticlesProps>`
  display: grid;
  grid-template-columns: 1fr;

  margin-top: 16px;

  ${({ hoverTextColor }) =>
    hoverTextColor?.length &&
    css`
      ${Article} {
        span:hover {
          color: ${colors[hoverTextColor] ?? hoverTextColor};
          text-decoration: underline;
          transition: color 0.2s linear, text-decoration 0.2s linear;
          cursor: pointer;
        }
      }
    `}
`;
